var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',[_c('div',{staticClass:"spinner-container",staticStyle:{"margin":"auto"}},[_c('div',{attrs:{"id":"spinner"}}),_c('p',{staticClass:"title-text"},[_vm._v(_vm._s(_vm.lang=='en' ? 'Uploading image ...':'이미지 업로드 중 ...'))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }